<template>
  <div>
    <v-flex v-if="relatedValue" xs12 class="m-4" style="border: 1px dashed orange">
      <span><strong>Kommentar fra innflytting:</strong> {{relatedValue}}</span>
    </v-flex>
    <v-textarea v-if="model" v-model="model.value" v-bind="theProps" v-on:input="inputChange" />
  </div>
</template>


<script>
  export default {
    props: ['value', 'theProps', 'relatedVmodel'],
    data() {
      return {
      }
    },
    computed: {
      model: function() {
        if(this.value != null) {
          if(this.value.value != null && this.value.value != undefined) {
            return this.value
          }
        }
        return null
      },
      relatedValue: function() {
        if(this.relatedVmodel) {
          if(this.relatedVmodel.value) {
            return this.relatedVmodel.value
          }
        }
        if(this.value) {
          if(this.value.relatedValue != null && this.value.relatedValue != undefined) {
            return this.value.relatedValue
          }
        }
        return null
      }
    },
    methods: {
      inputChange: function(event) {
        this.$emit('update-fields');
      }
    }
  }
</script>